module.exports = new __parcel__URL__("Design Sprint Hover.e398d42e.svg").toString();